import { Component, Element, h, Host, Listen } from "@stencil/core";
import { scrollToTarget } from "../../../utils/scrollToTarget";
import { elementsSelectors } from "../supported-elements-selectors";

/**
 * @slot (default) - insert the content of the various form steps, each wrapped
 * in a ux-form-step element
 */

@Component({
    tag: "ux-form-steps"
})
export class MultipleStepForm {
    private baseClass = "ux-form-steps";
    private tabContainer: HTMLUxTabContainerElement;
    private uxFormElement: HTMLUxFormElement;

    @Element() element!: HTMLUxFormStepsElement;

    private nextStepButton = "data-ux-form-steps-next";
    private previousStepButton = "data-ux-form-steps-prev";

    connectedCallback() {
        // @ts-expect-error Check for typing
        this.uxFormElement = this.element.closest("ux-form");
    }

    @Listen("click", { target: "window" })
    async handleButtonClicks(e: Event) {
        const eTarget = e.target as HTMLElement;
        const activeTab = this.element.querySelector("ux-tab.is-active") as HTMLUxTabElement;
        if (!this.element.contains(eTarget)) {
            return;
        }
        if (eTarget.hasAttribute(this.nextStepButton)) {
            await this.validateFormStep(activeTab);
            setTimeout(async () => {
                const isActiveStepValid = this.isFormStepValid(activeTab);
                if (isActiveStepValid) {
                    await this.goToNextStep(activeTab);
                    scrollToTarget({
                        target: this.element,
                        additionalOffsetTop: 30
                    });
                }
            }, 100);
        } else if (eTarget.hasAttribute(this.previousStepButton)) {
            await this.goToPreviousStep(activeTab);
            scrollToTarget({
                target: this.element,
                additionalOffsetTop: 30
            });
        }
    }

    private goToNextStep = async (activeTab: HTMLUxTabElement) => {
        const activeTabStep = activeTab.closest("ux-form-step");
        const nextTabStep = activeTabStep?.nextElementSibling?.querySelector("ux-tab");
        if (!nextTabStep) {
            return;
        }
        // @ts-expect-error Check for typing
        await this.tabContainer.setActiveTab(nextTabStep.getAttribute("tab-id"));
    };

    private goToPreviousStep = async (activeTab: HTMLUxTabElement) => {
        const activeTabStep = activeTab.closest("ux-form-step");
        const prevTabStep = activeTabStep?.previousElementSibling?.querySelector("ux-tab");
        if (!prevTabStep) {
            return;
        }
        // @ts-expect-error Check for typing
        await this.tabContainer.setActiveTab(prevTabStep.getAttribute("tab-id"));
    };

    private validateFormStep = async (activeStep: HTMLUxTabElement) => {
        await this.uxFormElement.validateElements(activeStep);
    };

    private isFormStepValid = (activeStep: HTMLUxTabElement): boolean => {
        const formElements = Array.from(activeStep.querySelectorAll(elementsSelectors.join(", ")));
        let isValid = true;
        // @ts-expect-error Check for typing
        formElements.forEach((formElement: HTMLUxInputFieldElement) => {
            if (formElement.error) {
                isValid = false;
            }
        });
        return isValid;
    };

    render() {
        return (
            <Host class={this.baseClass}>
                {/* @ts-expect-error Check for typing */}
                <ux-tab-container ref={(el: HTMLUxTabContainerElement) => (this.tabContainer = el)} no-navigation>
                    <slot />
                </ux-tab-container>
            </Host>
        );
    }
}
